export default "__VITE_ASSET__CduM77Cm__"